<template>
    <div class="h-100">
        <b-container class="p-0" fluid>
            <b-row align-h="center">
                <b-col md="10">
                    <h1 class="m-0 mb-2">{{ $t("mainmenu.apps") }}</h1>

                    <b-row>
                        <b-col lg="3" md="3" xl="2">
                            <b-card header-class="card-header-avatar">
                                <template #header
                                    ><h4>{{ $t("Filters") }}</h4></template
                                >
                                <b-card-text>
                                    <b-form-input
                                        v-model="filterText"
                                        :placeholder="$t('Search')"
                                        class="w-100 mb-1"
                                    ></b-form-input>
                                    <b-form-radio v-model="filterState" value="-1"
                                        >{{ $t("entities.apps.all") }}
                                    </b-form-radio>
                                    <b-form-radio v-model="filterState" value="1"
                                        >{{ $t("entities.apps.installed") }}
                                    </b-form-radio>
                                    <b-form-radio v-model="filterState" value="0"
                                        >{{ $t("entities.apps.not-installed") }}
                                    </b-form-radio>
                                </b-card-text>
                            </b-card>
                        </b-col>
                        <b-col lg="9" md="9" xl="10">
                            <b-card-group class="responsive" deck>
                                <b-card
                                    v-for="(app, index) in filteredResults"
                                    :key="app.id"
                                    header-class="card-header-avatar"
                                >
                                    <template #header>
                                        <img
                                            :src="lodashGet(app, 'package.saysimple.icon', '/mstile-70x70.png')"
                                            class="mr-1 round-large"
                                            height="35"
                                        />
                                        <h4>{{ app.name }}</h4>
                                    </template>
                                    <b-card-text class="text-secondary">
                                        <!-- {{ lodashGet(app, "package.version", "UNAVAILABLE") }} -->
                                        <small>{{ lodashGet(app, "package.saysimple.description", "N/A") }}</small>
                                        <!--pre>{{ JSON.stringify(app, null, "\t") }}</pre-->
                                    </b-card-text>
                                    <template #footer>
                                        <div class="w-100 text-right">
                                            <div v-if="app.name == 'Zapier'">
                                                <b-button
                                                    class="mb-50 ml-50"
                                                    variant="primary"
                                                    @click.prevent="openApp(app.name)"
                                                >
                                                    {{ $t("entities.conversation.Open") }}
                                                </b-button>
                                            </div>
                                            <div v-else-if="app.name == 'Flow Builder'">
                                                <b-button
                                                    v-if="app.settings.active"
                                                    class="mb-50 font-weight-normal"
                                                    variant="light"
                                                    @click.prevent="saveAppSettings(app, { active: false }, true)"
                                                >
                                                    <font-awesome-icon class="mr-50" icon="trash" />
                                                    {{ $t("entities.apps.uninstall") }}
                                                </b-button>
                                                <b-button
                                                    v-else
                                                    class="mb-50 mr-50 font-weight-normal"
                                                    variant="primary"
                                                    @click.prevent="saveAppSettings(app, { active: true }, false)"
                                                >
                                                    <font-awesome-icon class="mr-50" icon="down-to-line" />
                                                    {{ $t("entities.apps.install") }}
                                                </b-button>
                                                <b-button
                                                    v-if="app.settings.active"
                                                    class="mb-50 ml-50"
                                                    variant="primary"
                                                    @click="openFlowBuilder(app.name)"
                                                >
                                                    {{ $t("entities.conversation.Open") }}
                                                </b-button>
                                                <b-button
                                                    v-if="app.settings.active"
                                                    v-b-tooltip.hover
                                                    :title="$t('entities.apps.settings')"
                                                    class="mb-50 ml-50"
                                                    variant="primary"
                                                    @click.prevent="openApp(app.name)"
                                                >
                                                    <font-awesome-icon icon="gear" />
                                                </b-button>
                                            </div>
                                            <div v-else>
                                                <b-button
                                                    v-if="app.settings.active"
                                                    class="mb-50 font-weight-normal"
                                                    variant="light"
                                                    @click.prevent="saveAppSettings(app, { active: false }, true)"
                                                >
                                                    <font-awesome-icon class="mr-50" icon="trash" />
                                                    {{ $t("entities.apps.uninstall") }}
                                                </b-button>
                                                <b-button
                                                    v-else
                                                    class="mb-50 mr-50 font-weight-normal"
                                                    variant="primary"
                                                    @click.prevent="saveAppSettings(app, { active: true }, false)"
                                                >
                                                    <font-awesome-icon class="mr-50" icon="down-to-line" />
                                                    {{ $t("entities.apps.install") }}
                                                </b-button>

                                                <b-button
                                                    v-if="app.settings.active"
                                                    v-b-tooltip.hover
                                                    :title="$t('entities.apps.settings')"
                                                    class="mb-50 ml-50"
                                                    variant="primary"
                                                    @click.prevent="openApp(app.name)"
                                                >
                                                    <font-awesome-icon icon="gear" />
                                                </b-button>
                                            </div>
                                        </div>
                                    </template>
                                </b-card>
                            </b-card-group>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import {
    BButton,
    BCard,
    BCardGroup,
    BCardText,
    BCol,
    BContainer,
    BDropdown,
    BDropdownItem,
    BFormInput,
    BFormRadio,
    BPagination,
    BRow,
    BTab,
    BTable,
    BTabs,
    VBTooltip,
} from "bootstrap-vue";
import { computed, ref } from "@vue/composition-api/dist/vue-composition-api";

import { useRouter } from "@core/utils/utils";

import { useApps } from "@/composables/useApps";
import AppUtils from "@/utils/apps";
import { get as lodashGet } from "lodash";
import { useToast } from "vue-toastification/composition";
import i18n from "@/libs/i18n";
import { getUserData } from "@/auth/getUserData";

export default {
    components: {
        BContainer,
        BButton,
        BCard,
        BCol,
        BDropdown,
        BDropdownItem,
        BFormInput,
        BFormRadio,
        BPagination,
        BRow,
        BTable,
        BTabs,
        BTab,
        BCardText,
        BCardGroup,
    },
    directives: {
        "b-tooltip": VBTooltip,
    },
    setup(props, { emit, root }) {
        const { router } = useRouter();
        const openApp = (appName) => {
            router.replace({
                name: "apps-open",
                params: {
                    appName,
                },
            });
        };
        const { loadApps, apps } = useApps();

        const toast = useToast();

        const total = ref(0);

        loadApps();

        const filterText = ref("");
        const filterState = ref(-1);

        const filteredResults = computed(() => {
            let filteredApps = apps.value || [];
            const filterStateValue = Number(filterState.value);

            if (filterStateValue === 1) {
                filteredApps = filteredApps.filter((app) => app.settings.active);
            } else if (filterStateValue === 0) {
                filteredApps = filteredApps.filter((app) => !app.settings.active);
            }

            return filteredApps.filter((app) => app.name.toLowerCase().indexOf(filterText.value.toLowerCase()) !== -1);
        });

        const openFlowBuilder = () => {
            const flowBuilderApp = apps.value.find((app) => app.name === "Flow Builder");
            let baseUrl = "";

            if (flowBuilderApp.utils.getSetting("acceptanceActive", false) === true) {
                baseUrl = "https://flows.saysimple-accept.nl";
            } else {
                baseUrl = "https://flowbuilder.saysimple.io";
            }
            const url = `${baseUrl}/autologin/${flowBuilderApp.utils.getSetting(
                "apiKey"
            )}/${flowBuilderApp.utils.getSetting("apiSecret")}/${getUserData().id || 1}?locale=${i18n.t(
                "@app/flows.content.language"
            )}`;
            window.open(url, "_blank");
        };

        // context.root.$bvModal.msgBoxOk;

        const saveAppSettings = (app, settings, confirm) => {
            if (confirm) {
                root.$bvModal
                    .msgBoxConfirm(i18n.t("entities.apps.uninstall-confirm-text"), {
                        title: i18n.t("confirm.Are you sure?"),
                        cancelTitle: i18n.t("confirm.Cancel"),
                        cancelVariant: "light",
                        okTitle: i18n.t("entities.apps.uninstall"),
                        hideHeaderClose: false,
                        headerCloseVariant: "light",
                        centered: true,
                    })
                    .then((result) => {
                        if (result) {
                            AppUtils(app).saveSettings(settings);
                        }
                    });

                return;
            }

            AppUtils(app).saveSettings(settings);
        };

        return {
            apps,
            filterText,
            filterState,
            filteredResults,
            openApp,
            total,
            lodashGet,
            saveAppSettings,
            openFlowBuilder,
        };
    },
};
</script>
